import { makeAutoObservable } from 'mobx'

import { ShopRootStore } from 'shop/stores/shopRoot.store'
import {
  CURRENCY_COUNTRY_MAP,
  KLARNA_COUNTRIES,
  STIPE_ELEMENT_OPTIONS_DEFAULT,
} from 'constants/paymentSettingShared.constants'
import type { StripeElementsOptionsMode } from '@stripe/stripe-js'

import { KLARNA_KEY } from 'constants/options.constants'
import {
  StripeElementOptions,
  StripePaymentElement,
  StripePaymentMethod,
} from '../../interfaces/payment-method-interfaces/StripePaymentMethod'

export class ShopKlarnaPaymentMethodStore implements StripePaymentMethod, StripePaymentElement, StripeElementOptions {
  storeName = 'ShopKlarnaPaymentMethodStore'
  root: ShopRootStore = null

  constructor(root: ShopRootStore) {
    this.root = root

    makeAutoObservable(this)
  }

  isAppActive() {
    return this.root.sellerStore.isAppActive(KLARNA_KEY)
  }

  isAvailable = (activeCountry: string, currency: string): boolean =>
    this.isAppActive() &&
    KLARNA_COUNTRIES.includes((activeCountry || 'DE').toUpperCase()) &&
    CURRENCY_COUNTRY_MAP[currency.toUpperCase()]?.includes(activeCountry)

  getStripeElementPayload = ({
    isDealsPage,
    isManagePage,
  }: {
    isDealsPage: boolean
    isManagePage: boolean
  }): StripeElementsOptionsMode => {
    let store = null

    if (isDealsPage) {
      store = this.root.dealsStore
    } else if (isManagePage) {
      store = this.root.ordersStore
    } else {
      store = this.root.paymentStore
    }

    return (
      (store?.getKlarnaStripeElementPayload && store.getKlarnaStripeElementPayload()) || STIPE_ELEMENT_OPTIONS_DEFAULT
    )
  }

  getPaymentElementOptions = () => ({
    fields: {
      billingDetails: 'never',
    },
  })
}
